export const Config = {
  baseFolder: '',
  apiRoot: 'https://admin.udruzenjeosiguravaca.net/api/v1/',
  // apiRoot: 'https://uosportal.normasoft.net/api/v1/',
  protectionOff: false,
  reCaptchaKey: '6LfIUegnAAAAAHEGLrGVf15ppxIhtSP_vxPRGFcJ'
};

export const currentEventId = '5f306756-ccf6-4e9c-8c4a-13c25704a9a9';
